// Shared display helpers for ColourMatch.
//
// `prettyTitle` masks auto-generated project IDs (e.g. "colourmatch-1780...")
// as the friendly default "Untitled property" so first-time homeowners never
// see a database ID in the UI. Used by /projects card and Workspace title.
// Keep all auto-name patterns in this one place — Projects.jsx + Workspace.jsx
// both call this helper.

export function prettyTitle(raw) {
  if (!raw) return "Untitled property";
  const t = String(raw).trim();
  if (/^colourmatch[-_]\d+$/i.test(t)) return "Untitled property";
  if (/^audit[-_]\d+$/i.test(t)) return "Untitled property";
  if (/^untitled project$/i.test(t)) return "Untitled property";
  if (/^cm[-_]\d+$/i.test(t)) return "Untitled property";
  if (/^\d+$/.test(t)) return "Untitled property";
  return t;
}
